<template>
  <div class="account">
    <a-modal :visible="visible" @cancel="visible=false" title='过期天数' width='460px' @ok='sub'>
      <a-row align='middle' justify='space-between' type='flex'>
        <label>超期天数：</label>
        <a-input placeholder='请输入超期天数' v-model='smlform.day' type='number' style="width:300px;"> </a-input>
      </a-row>
    </a-modal>
    <div class="tcon wbg">
      <div class="nList" v-if='$common.AUTH("over:index")'>
        <div class="ntable" v-for='(i,index) in data' :key='index'>
          <table>
            <thead>
              <td width='50%'>进度名称</td>
              <td width='30%'>天数</td>
              <td width='30%'>操作</td>
            </thead>
            <tbody>
              <tr v-for='(j,ind) in i.list'>
                <td>{{j.step_title}}</td>
                <td>{{j.day}}</td>
                <td> <a href='javascript:void(0);' @click='smlform.id=j.id;smlform.day=j.day;visible=true;' v-if='$common.AUTH("over:edit")'>修改</a></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="nqx" v-else>您没有该页面的访问权限，请联系管理员开通。</div>
    </div>
  </div>
</template>
<script>
import { overEdit, overSet } from '@/server/api'
export default {
  data() {
    return {
      smlform: {
        day: ''
      },
      visible: false,
      data: { 0: { list: [] }, 1: { list: [] }, 2: { list: [] } }
    }
  },
  created() {
    this.query()
  },
  methods: {
    sub() {
      overEdit(this.smlform).then(e => {
        this.$message.success({ content: '修改成功' })
        this.visible = false
        this.query()
      })
    },
    query() {
      overSet().then((res) => {
        let arr = { 0: { list: [] }, 1: { list: [] }, 2: { list: [] } }
        res.list.filter(ele => { return ele.step < 111 || ele.step > 114 }).map((ele, index) => {
          // if (index <= 10) {
          //   arr[0].list.push(ele)
          // }
          // else if (index > 10 && index <= 21) {
          //   arr[1].list.push(ele)
          // }
          // else {
          //   arr[2].list.push(ele)
          // }
          if (index <= 12) {
            arr[0].list.push(ele)
          }
          else if (index > 12 && index <= 25) {
            arr[1].list.push(ele)
          }
          else {
            arr[2].list.push(ele)
          }
        })
        this.data = arr
      })

    }
  }
}
</script>
<style lang="less" scoped>
.tcon {
  padding: 20px;
  min-height: 760px;
  .nList {
    display: flex;
    justify-content: space-between;
    .ntable {
      flex: 1;
      margin-right: 20px;
      table {
        width: 100%;
      }
      thead {
        td {
          height: 36px;
          background: #f4f5f9;
          border: 1px solid #efefef;
          padding-left: 20px;
        }
      }
      tbody {
        border-right: 1px solid #efefef;
        td {
          height: 54px;
          border-bottom: 1px solid #efefef;
          border-left: 1px solid #efefef;
          padding-left: 20px;
        }
      }
      &:nth-last-child(1) {
        margin: 0;
      }
    }
  }
}
.modal-footer {
  text-align: center;
  .cancel {
    background-color: #b2c9e1;
    border-color: #b2c9e1;
    margin-left: 30px;
  }
}
</style>
